import * as types from "../types/walletIssue.types";

const initialState = {
  walletIssueData: [],
  walletIssuePagination: [],
};

const WalletIssueReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_WALLET_ISSUE_DATA:
      return { ...state, walletIssueData: action.payload };
    case types.SET_WALLET_ISSUE_PAGINATION:
      return { ...state, walletIssuePagination: action.payload };
    case types.RESET_WALLET_ISSUE_REDUCER:
      return { 
        ...state, 
        walletIssueData: [],
        walletIssuePagination: [],      
      };
    default:
      return state;
  }
};
export default WalletIssueReducer;
